var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:'badge badge-pill '+_vm.application.status,attrs:{"title":"Application status"}},[_vm._v(_vm._s(_vm.application.status))])
}
var staticRenderFns = []

export { render, staticRenderFns }